import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Hero = () => {
  return (
    <section id="home" className="py-5 bg-light" style={{ marginTop: '56px', minHeight: '90vh', display: 'flex', alignItems: 'center' }}>
      <Container>
        <Row className="align-items-center">
          <Col lg={12} className="text-center fade-in-up">
            <h1 className="display-3 fw-bold mb-4">
              Master-Level Software Engineer
              <br />
              <span className="text-primary">Available for Hire</span>
            </h1>
            <p className="lead mb-4 text-muted" style={{ maxWidth: '800px', margin: '0 auto 2rem' }}>
              I architect and build production-grade systems that scale. Specializing in backend engineering,
              system design, and delivering solutions that solve complex business problems.
            </p>
            <div className="d-flex gap-3 justify-content-center">
              <Button href="#contact" variant="primary" size="lg">
                Start a Project
              </Button>
              <Button href="#services" variant="outline-primary" size="lg">
                View Services
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;